module.exports = __webpack_public_path__ + "media/images/features/wedding-ceremony-cost/wedding-ceremony-cost-og-image-f09f2c9406044551940127673fd06c5c.png";